<template>
	<div
		ref="sports-list-ref"
		class="sports-list"
		:key="'sports-list'"
		tabindex="-100"
		:class="{
			focused: isFocused && $store.getters.layout == 'Mobile',
			'sports-list-wrapper': $store.getters.layout == 'Mobile',
			open: isOpen && $store.getters.layout == 'Mobile',
			closed: $store.getters.layout == 'Mobile' && isOpen == false,
		}"
		@focusout="close($event, null)"
	>
		<div
			ref="sports-list-container-ref"
			:class="{
				'sports-list-container': $store.getters.layout == 'Mobile',
				wrapper: !draggingDisabled,
			}"
		>
			<div
				:class="{
					'drop-down-contents': $store.getters.layout == 'Mobile',
				}"
			>
				<!-- Main Sports -->
				<div
					data-v-step-2="dropMenu2"
					data-v-step-3="dropMenu3"
					v-touch:swipe.bottom="swipeOpen"
					v-touch:swipe.right="swipeRight"
					:class="{
						'sports-list__main__sports': $store.getters.layout == 'Mobile',
					}"
				>
					<!--		Sports List-->
					<div
						:class="{
							'sports-list__main__sports__container':
								$store.getters.layout == 'Mobile',
							open: isOpen && $store.getters.layout == 'Mobile',
						}"
					>
						<div
							:class="{
								'main-sports-draggable-container':
									$store.getters.layout == 'Mobile',
								overlap: $store.getters.layout == 'Mobile',
							}"
						>
							<transition name="fade">
								<div
									key="unionSportsItems"
									v-if="isOpen == false && $store.getters.layout == 'Mobile'"
									class="main-sports-draggable scroll-x overlap-item-1"
								>
									<div :class="{
										'main-sports-transition-group scroll-x scroll-x':1,
										'scroll-x-start': isOpen == false && unionSports.filter((item) => item.visible==true).length < 6,
									}">
										<!-- Union Sports Items -->
										<div
											v-show="
												unionSports.length > 0 &&
													sport.visible == true &&
													isOpen == false &&
													$store.getters.layout == 'Mobile'
											"
											v-for="sport in unionSports"
											:key="'union_' + sport.sport_id"
											:ref="'union_' + sport.sport_id"
										>
											<sports-list-item
												:dragging-disabled="draggingDisabled"
												:sport="sport"
												:selected-sport="selectedSport"
												:router-link-class="{
													'sports-list__item': 1,
													'sports-list__main__sports__container__item':
														$store.getters.layout == 'Mobile',
													active:
														selectedSport != null &&
														selectedSport.sport_id == sport.sport_id &&
														!isLive,
													editing:
														!draggingDisabled &&
														$store.getters.layout == 'Mobile',
												}"
												:span-class="{
													'sports-list__item__label': 1,
													narrow: 1,
													editing:
														!draggingDisabled &&
														$store.getters.layout == 'Mobile',
												}"
												@close="close"
												@toggleEdit="toggleEdit"
											/>
										</div>
										<!-- Union Sports Items -->
									</div>
								</div>

								<draggable
									v-else-if="
										isOpen == true || $store.getters.layout == 'Desktop'
									"
									:key="'mainSportsDraggable'"
									:empty-insert-threshold="150"
									:class="{
										'main-sports-draggable': $store.getters.layout == 'Mobile',
										'overlap-item-2': $store.getters.layout == 'Mobile',
									}"
									tag="div"
									v-model="mainSports"
									v-bind="dragOptions"
									:disabled="draggingDisabled"
									@start="isDragging = true"
									@end="isDragging = false"
								>
									<transition-group
										:class="{
											'main-sports-transition-group':
												$store.getters.layout == 'Mobile',
										}"
										type="transition"
										:name="!isDragging ? 'flip-list' : 'fade'"
									>
										<!-- Main Sports Items -->
										<sports-list-item
											v-show="
												mainSports.length > 0 &&
													sport.visible == true &&
													(isOpen == true || $store.getters.layout == 'Desktop')
											"
											v-for="sport in mainSports"
											:key="sport.sport_id"
											:dragging-disabled="draggingDisabled"
											:sport="sport"
											:selected-sport="selectedSport"
											:router-link-class="{
												'sports-list__item': 1,
												'sports-list__main__sports__container__item':
													$store.getters.layout == 'Mobile',
												active:
													selectedSport != null &&
													selectedSport.sport_id == sport.sport_id &&
													!isLive,
												editing:
													!draggingDisabled &&
													$store.getters.layout == 'Mobile',
											}"
											:span-class="{
												'sports-list__item__label': 1,
												narrow: 1,
												editing:
													!draggingDisabled &&
													$store.getters.layout == 'Mobile',
												open: isOpen == true,
											}"
											@close="close"
											@toggleEdit="toggleEdit"
										/>
										<!-- Main Sports Items -->
									</transition-group>
								</draggable>
							</transition>

							<div
								class="no-data-label"
								v-if="
									mainSports.length == 0 &&
										$store.getters.layout == 'Mobile' &&
										draggingDisabled == false
								"
							>
								{{ $t("general.tour.drag-and-drop-an-option-of-your-choice") }}
							</div>
						</div>
					</div>
					<!--		Sports List -->
				</div>
				<!-- Main Sports -->

				<div
					v-if="$store.getters.layout == 'Mobile' && !toastVisible"
					class="divider"
				></div>
				<div
					class="toast-container"
					v-if="
						$store.getters.layout == 'Mobile' &&
							isOpen == true &&
							toastVisible == true &&
							dropMenuToastClosed == false
					"
				>
					<toast
						:message="$t('general.tour.long-press-drag-drop-items')"
						toast-type=""
						@click="handleClosedToast"
					></toast>
				</div>

				<!-- Other Sports -->
				<div
					:class="{
						'sports-list__other__sports': $store.getters.layout == 'Mobile',
						close: isOpen == false,
					}"
				>
					<sport-list-loader v-show="!loaded" />

					<div
						:class="{
							'sports-list__other__sports__container':
								$store.getters.layout == 'Mobile',
						}"
					>
						<draggable
							:key="'otherSportsDraggable'"
							:empty-insert-threshold="150"
							:class="{
								draggable: $store.getters.layout == 'Mobile',
							}"
							tag="div"
							v-model="otherSports"
							v-bind="dragOptions"
							:disabled="draggingDisabled"
							@start="isDragging = true"
							@end="isDragging = false"
						>
							<transition-group
								:class="{
									'transition-group': $store.getters.layout == 'Mobile',
								}"
								type="transition"
								:name="!isDragging ? 'flip-list' : 'fade'"
							>
								<!--		Sports List-->
								<sports-list-item
									v-show="otherSports.length > 0 && sport.visible == true"
									v-for="sport in otherSports"
									:key="sport.sport_id"
									:dragging-disabled="draggingDisabled"
									:sport="sport"
									:selected-sport="selectedSport"
									:router-link-class="{
										'sports-list__item': 1,
										'sports-list__other__sports__item':
											$store.getters.layout == 'Mobile',
										active:
											selectedSport != null &&
											selectedSport.sport_id == sport.sport_id &&
											!isLive,
										editing:
											!draggingDisabled && $store.getters.layout == 'Mobile',
									}"
									:span-class="{
										'sports-list__item__label': 1,
										narrow: 1,
										editing:
											!draggingDisabled && $store.getters.layout == 'Mobile',
									}"
									@close="close"
									@toggleEdit="toggleEdit"
								/>
								<!--		Sports List -->
							</transition-group>
						</draggable>
					</div>

					<div
						class="no-data-label"
						v-if="
							otherSports.length == 0 &&
								$store.getters.layout == 'Mobile' &&
								draggingDisabled == false
						"
					>
						{{ $t("general.tour.drag-and-drop-an-option-of-your-choice") }}
					</div>
				</div>
				<!-- Other Sports -->

				<div v-if="$store.getters.layout == 'Mobile'" class="divider"></div>

				<!-- Other Links -->
				<div
					v-if="$store.getters.layout == 'Mobile'"
					v-touch:swipe="
						() => {
							if (isDragging == false) {
								swipeClose();
							}
						}
					"
					:class="{
						'sports-list__other__links': $store.getters.layout == 'Mobile',
						close: $store.getters.layout == 'Mobile' && isOpen == false,
					}"
				>
					<div
						:class="{
							'sports-list__other__links__container':
								$store.getters.layout == 'Mobile',
						}"
					>
						<draggable
							:key="'thirdRowDraggable'"
							:empty-insert-threshold="200"
							:class="{
								draggable: $store.getters.layout == 'Mobile',
							}"
							tag="div"
							v-model="thirdRow"
							v-bind="dragOptions"
							:disabled="draggingDisabled"
							@start="isDragging = true"
							@end="isDragging = false"
						>
							<transition-group
								:class="{
									'transition-group': $store.getters.layout == 'Mobile',
								}"
								type="transition"
								:name="!isDragging ? 'flip-list' : 'fade'"
							>
								<!--		Sports List-->
								<sports-list-item
									v-show="thirdRow.length > 0 && sport.visible == true"
									v-for="sport in thirdRow"
									:key="sport.sport_id"
									:dragging-disabled="draggingDisabled"
									:sport="sport"
									:selected-sport="selectedSport"
									:router-link-class="{
										'sports-list__item': 1,
										'sports-list__other__links__container__item':
											$store.getters.layout == 'Mobile',
										active:
											selectedSport != null &&
											selectedSport.sport_id == sport.sport_id &&
											!isLive,
									}"
									:span-class="{
										'sports-list__item__label': 1,
										narrow: 1,
										editing:
											!draggingDisabled && $store.getters.layout == 'Mobile',
									}"
									@close="close"
								/>
								<!--		Sports List -->
							</transition-group>
						</draggable>
					</div>
				</div>
				<!-- Other Links -->
			</div>

			<!-- Menu -->
			<div
				data-v-step="dropMenu1"
				data-v-step-4="dropMenu4"
				data-v-step-5="dropMenu5"
				v-if="$store.getters.layout == 'Mobile'"
				:class="{
					more__container: $store.getters.layout == 'Mobile',
					open: !draggingDisabled,
				}"
			>
				<!-- Menu Button -->
				<div
					@click="toggleDropdownMenu"
					:class="{
						'menu-button': $store.getters.layout == 'Mobile',
						editing: !draggingDisabled,
					}"
				>
					<svg
						:class="{
							open: isOpen,
							closed: !isOpen,
						}"
						width="6"
						height="18"
						viewBox="0 0 6 18"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M5.1875 9C5.1875 9.43265 5.05921 9.85558 4.81884 10.2153C4.57847 10.575 4.23683 10.8554 3.83712 11.021C3.43741 11.1866 2.99757 11.2299 2.57324 11.1455C2.14891 11.0611 1.75913 10.8527 1.45321 10.5468C1.14728 10.2409 0.938938 9.8511 0.854533 9.42676C0.770128 9.00243 0.813448 8.5626 0.979015 8.16288C1.14458 7.76317 1.42496 7.42153 1.78469 7.18116C2.14442 6.9408 2.56735 6.8125 3 6.8125C3.57999 6.81307 4.13605 7.04373 4.54616 7.45384C4.95628 7.86395 5.18693 8.42002 5.1875 9ZM3 4.9375C3.43265 4.9375 3.85558 4.80921 4.21531 4.56884C4.57504 4.32848 4.85542 3.98683 5.02099 3.58712C5.18655 3.18741 5.22987 2.74757 5.14547 2.32324C5.06106 1.89891 4.85273 1.50913 4.5468 1.2032C4.24087 0.897278 3.85109 0.688938 3.42676 0.604533C3.00243 0.520128 2.56259 0.563448 2.16288 0.729015C1.76317 0.894581 1.42153 1.17496 1.18116 1.53469C0.940796 1.89442 0.812501 2.31735 0.812501 2.75C0.813074 3.32999 1.04373 3.88605 1.45384 4.29616C1.86395 4.70628 2.42002 4.93693 3 4.9375ZM3 13.0625C2.56735 13.0625 2.14442 13.1908 1.78469 13.4312C1.42496 13.6715 1.14458 14.0132 0.979015 14.4129C0.813448 14.8126 0.770128 15.2524 0.854533 15.6768C0.938938 16.1011 1.14728 16.4909 1.45321 16.7968C1.75913 17.1027 2.14891 17.3111 2.57324 17.3955C2.99757 17.4799 3.43741 17.4366 3.83712 17.271C4.23683 17.1054 4.57847 16.825 4.81884 16.4653C5.05921 16.1056 5.1875 15.6826 5.1875 15.25C5.18693 14.67 4.95628 14.114 4.54616 13.7038C4.13605 13.2937 3.57999 13.0631 3 13.0625Z"
							fill="#98A9BC"
						/>
					</svg>
					<span v-if="isOpen" class="">{{ $t("general.tour.less") }}</span>
					<span v-if="!isOpen" class="">{{ $t("general.tour.more") }}</span>
					<span
						v-if="
							notificationDot.visible == true &&
								notificationDot.visited == false
						"
						class="red-dot"
						>N</span
					>
				</div>
				<!-- Menu Button -->

				<!-- Edit Button -->
				<div
					@click="
						() => {
							// Toggle draggable
							draggingDisabled = draggingDisabled == true ? false : true;
							$refs['sports-list-ref'].focus();
						}
					"
					:class="{
						'menu-button': $store.getters.layout == 'Mobile',
						editing: !draggingDisabled,
					}"
					v-if="draggingDisabled == false"
				>
					<svg
						v-show="draggingDisabled == false"
						v-if="isOpen"
						:class="{
							open: isOpen,
							editing: !draggingDisabled,
						}"
						width="16"
						height="54"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<circle cx="8" cy="8" r="8" fill="#60981A" />
						<path
							d="M6.71875 10.8594C6.78125 10.9531 6.875 10.9844 7 10.9844C7.10938 10.9844 7.20312 10.9531 7.28125 10.8594L11.8906 6.26562C11.9531 6.20312 12 6.10938 12 5.98438C12 5.875 11.9531 5.78125 11.8906 5.70312L11.3125 5.14062C11.2344 5.0625 11.1406 5.01562 11.0312 5.01562C10.9219 5.01562 10.8281 5.0625 10.75 5.14062L7 8.89062L5.25 7.14062C5.15625 7.0625 5.0625 7.01562 4.95312 7.01562C4.84375 7.01562 4.75 7.0625 4.6875 7.14062L4.10938 7.70312C4.03125 7.78125 4 7.875 4 7.98438C4 8.10938 4.03125 8.20312 4.10938 8.26562L6.71875 10.8594Z"
							fill="#F2F2F2"
						/>
					</svg>
					<span v-show="draggingDisabled == false" v-if="isOpen">{{
						$t("general.done")
					}}</span>
				</div>
				<!-- Edit Button -->

				<!-- Reset Button -->
				<div
					v-if="draggingDisabled == false"
					@click="showBottomSheet"
					:class="{
						'menu-button': $store.getters.layout == 'Mobile',
						editing: !draggingDisabled,
					}"
				>
					<svg
						id="reset"
						width="20"
						height="54"
						viewBox="0 0 1024 1024"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M931.07 384.75a368 368 0 0 0-704 95.25H64l192 192 192-192H288.91C312 333.51 439.12 221.13 592 221.13c169.21 0 306.87 137.66 306.87 306.87S761.21 834.87 592 834.87a307.37 307.37 0 0 1-194.56-69.55 30.57 30.57 0 0 0-38.79 47.25 368.1 368.1 0 0 0 572.42-427.82z"
							fill="#98A9BC"
						/>
					</svg>
					<span>{{ $t("general.tour.reset") }}</span>
				</div>
				<!-- Reset Button -->
			</div>
			<!-- Menu -->
		</div>

		<!-- SVG ICONS -->
		<sports-list-items-icons />
		<!-- SVG ICONS -->

		<!-- PRODUCT TOUR -->
		<v-tour
			name="dropMenuTour"
			:steps="steps"
			:callbacks="productTourCallbacks"
			:options="{ debug: false, highlight: false }"
		>
			<!--			<template v-slot:="tour">-->
			<!--				<transition>-->
			<!--					<v-step-->
			<!--						:key="tour.currentStep"-->
			<!--						:step="tour.steps[tour.currentStep]"-->
			<!--						:previous-step="tour.previousStep"-->
			<!--						:next-step="tour.nextStep"-->
			<!--						:stop="tour.stop"-->
			<!--						:skip="tour.skip"-->
			<!--						:is-first="tour.isFirst"-->
			<!--						:is-last="tour.isLast"-->
			<!--						:labels="tour.labels"-->
			<!--						:highlight="tour.highlight"-->
			<!--					>-->
			<!--					<template>-->
			<!--						<div slot="actions">-->
			<!--							<button @click="tour.previousStep" class="btn btn-primary">Previous step</button>-->
			<!--							<button @click="tour.nextStep" class="btn btn-primary">Next step</button>-->
			<!--						</div>-->
			<!--					</template>-->
			<!--					</v-step>-->
			<!--				</transition>-->
			<!--			</template>-->
		</v-tour>
		<!-- PRODUCT TOUR -->

		<!-- Bottom Sheet -->
		<bottom-sheet
			:ref="'bottomSheet'"
			v-if="canShowBottomSheet"
			@close="closeBottomSheet"
			@has-mounted="showBottomSheet"
		>
			<div class="bottom-sheet__container">
				<h1 class="bottom-sheet__title">{{ $t("general.tour.reset-menu") }}</h1>
				<h2 class="bottom-sheet__text">
					{{ $t("general.tour.reset-menu-to-default-order") }}
				</h2>

				<div class="bottom-sheet__buttons__container">
					<b-button
						class="button full button__secondary"
						@click="reset"
						:title="$t('general.tour.yes-reset-menu')"
					>
					</b-button>
					<b-button
						class="button no-bg full link text-center"
						@click="closeBottomSheet"
						:title="$t('general.cancel')"
					>
					</b-button>
				</div>
			</div>
		</bottom-sheet>
		<!-- Bottom Sheet -->
	</div>
</template>

<script>
import SportListLoader from "../Shared/SportListLoader.vue";
import draggable from "vuedraggable";
import SportsListItem from "../Prebets/SportsListItem.vue";
import SportsListItemsIcons from "../Prebets/SportsListItemsIcons.vue";
import _ from "lodash";
import analytics from "../../utils/analytics";
export default {
	name: "SportsList",
	components: {
		SportsListItemsIcons,
		SportsListItem,
		SportListLoader,
		draggable,
	},
	data() {
		return {
			fixedPosSports: ["soccer", "virtual", "bsl", "casino"],
			isOpen: false,
			isTourOpen: false,
			isTourDone: false,
			isFocused: false,
			editable: true,
			isDragging: false,
			delayedDragging: false,
			draggingDisabled: true,
			canShowBottomSheet: false,
			toastVisible: true,
			currentUnionSports: null,
			productTourCallbacks: null,
			steps: [
				{
					target: '[data-v-step="dropMenu1"]', // We're using document.querySelector() under the hood
					content:
						`<span style="font-size: var(--font-small);"><strong>` +
						this.$t("overlay-menu.new") +
						`</strong> ` +
						this.$t("general.tour.dropdown-menu") +
						`!</span>`,
					before: (type) =>
						new Promise((resolve, reject) => {
							// Time-consuming UI/async operation here
							this.draggingDisabled = true;
							resolve();
						}),
					params: {
						enableScrolling: false,
						placement: "bottom",
					},
				},
				{
					target: '[data-v-step-2="dropMenu2"]',
					content:
						`<span style="font-size: var(--font-small);">` +
						this.$t("general.tour.long-press-menu-items") +
						`</span>`,
					before: (type) =>
						new Promise((resolve, reject) => {
							// Time-consuming UI/async operation here
							this.draggingDisabled = true;
							resolve();
						}),
				},
				{
					target: '[data-v-step-3="dropMenu3"]',
					content:
						`<span style="font-size: var(--font-small);">` +
						this.$t("general.tour.reorder-menu-items") +
						`</span>`,
					before: (type) =>
						new Promise((resolve, reject) => {
							// Time-consuming UI/async operation here
							this.toggleEdit();
							resolve();
						}),
				},
				{
					target: '[data-v-step-4="dropMenu4"]',
					content:
						`<span style="font-size: var(--font-small);">` +
						this.$t("general.tour.reset-menu-to-default-order") +
						`</span>`,
					before: (type) =>
						new Promise((resolve, reject) => {
							// Time-consuming UI/async operation here
							this.toggleEdit();
							resolve();
						}),
				},
				{
					target: '[data-v-step-5="dropMenu5"]',
					content:
						`<span style="font-size: var(--font-small);">` +
						this.$t("general.tour.all-set") +
						`</span>`,
					before: (type) =>
						new Promise((resolve, reject) => {
							// Time-consuming UI/async operation here
							this.draggingDisabled = true;
							resolve();
						}),
				},
			],
		};
	},
	created() {
		let vm = this;
		vm.$root.$on("scroll-to-sport", vm.scrollToSports);
	},
	mounted() {
		this.productTourCallbacks = {
			onStart: this.productTourOnStart,
			onPreviousStep: this.productTourOnPreviousStep,
			onNextStep: this.productTourOnNextStep,
			onSkip: this.productTourOnSkip,
			onFinish: this.productTourOnFinish,
			onStop: this.productTourOnStop,
		};
		if (
			this.$store.getters.layout == "Mobile" &&
			this.productTour.dropMenu == false
		) {
			// Will run only if the user has not completed / skipped the product tour
			this.$store.dispatch("navigation/updateNotificationDotVisible", true);
			this.$store.dispatch("navigation/updateNotificationDotVisited", false);
		}
	},
	beforeDestroy() {
		let vm = this;
		vm.$root.$off("scroll-to-sport", vm.scrollToSports);
	},
	computed: {
		favoriteSports: {
			get() {
				return this.$store.getters["navigation/favoriteSports"];
			},
			set(value) {
				this.$store.commit("navigation/setFavoriteSports", value);
			},
		},
		mainSports: {
			get() {
				return this.$store.getters["navigation/mainSports"];
			},
			set(value) {
				this.$store.commit("navigation/setMainSports", value);
				this.$store.dispatch("navigation/updateUnionSports");
			},
		},
		otherSports: {
			get() {
				return this.$store.getters["navigation/otherSports"];
			},
			set(value) {
				this.$store.commit("navigation/setOtherSports", value);
				this.$store.dispatch("navigation/updateUnionSports");
			},
		},
		unionSports: {
			get() {
				return this.$store.getters["navigation/unionSports"];
			},
			set(value) {
				this.$store.commit("navigation/setUnionSports", value);
			},
		},
		thirdRow: {
			get() {
				return this.$store.getters["navigation/thirdRow"];
			},
			set(value) {
				this.$store.commit("navigation/setThirdRow", value);
			},
		},
		notificationDot() {
			return this.$store.getters["navigation/notificationDot"];
		},
		productTour() {
			return this.$store.getters["productTour/productTour"];
		},
		selectedSport() {
			return this.$store.getters.selectedSport;
		},
		sports() {
			return this.$store.getters.sports;
		},
		loaded() {
			return this.$store.getters.sportsLoaded;
		},
		dragOptions() {
			return {
				animation: 200,
				group: "description",
				disabled: !this.editable,
				delayedDragging: false,
				ghostClass: "ghost",
			};
		},
		isLive() {
			return ["live", "live-sport", "live-markets"].includes(this.$route.name);
		},
		dropMenuToastClosed() {
			return (
				this.$store.getters["settings/settings"].toast &&
				this.$store.getters["settings/settings"].toast.dropMenu
			);
		},
	},
	methods: {
		formatSportName(sportName) {
			return sportName
				.toLowerCase()
				.replace(/\s/gi, "_")
				.replace(/\-/gi, "_");
		},
		startDrag(evt, sport) {
			evt.dataTransfer.dropEffect = "move";
			evt.dataTransfer.effectAllowed = "move";
			evt.dataTransfer.setData("sport_id", sport.sport_id);
		},
		toggleOpen() {
			this.isOpen = !this.isOpen;
		},
		startProductTour() {
			if (
				this.$store.getters.layout == "Mobile" &&
				this.productTour.dropMenu == false
			) {
				// Will run only if the user has not completed / skipped the product tour
				this.$tours["dropMenuTour"].start();
			}
		},
		toggleEdit() {
			if (this.isOpen == true) {
				this.draggingDisabled = false;
				return false;
			}
		},
		toggleDropdownMenu() {
			let vm = this;
			// Toggle dropdown
			// Emit event to be handled to disable pull to refresh in prebets/Matches
			vm.isOpen = vm.isOpen == true ? false : true;
			vm.draggingDisabled = true;
			vm.startProductTour();
			if (vm.isOpen == true) {
				vm.$emit("usingDropdown", true);
				vm.$refs["sports-list-ref"].focus();
				vm.currentUnionSports = vm.unionSports; // Used to compare with unionSports on close to determine whether order changed and send dlp
			} else {
				vm.sendDlp();
				vm.$emit("usingDropdown", false);
				vm.scrollToSport(null);
			}
		},
		close(event, sportId) {
			let vm = this;

			if (vm.isTourDone == true) {
				// Leaves drop menu open after skipping/ finishing the tour
				vm.isTourDone = false;
				return;
			}

			if (vm.isTourOpen == false) {
				// Will allow the drop menu to remain open while going through the product tour

				if (vm.isOpen == true) {
					vm.$store.dispatch("navigation/updateNotificationDotVisited", true);
				}

				if (vm.draggingDisabled == true) {
					// Handles the blur event that calls the close method
					if (
						!event.currentTarget.contains(event.relatedTarget) ||
						event.relatedTarget == null
					) {
						vm.$refs["sports-list-container-ref"].scrollTo(0, 0);
						vm.scrollToSport(sportId);
						vm.isOpen = false;
					}
				}

				// Exit edit mode if user is in edit mode
				if (
					event.currentTarget.contains(event.relatedTarget) ||
					event.relatedTarget == null
				) {
					if (vm.draggingDisabled == false) {
						vm.$refs["sports-list-ref"].focus();
						vm.draggingDisabled = true;
					}
				}
			}
		},
		scrollToSports() {
			setTimeout(() => {
				this.scrollToSport(null);
			}, 300);
		},
		scrollToSport(sportId) {
			let vm = this;
			if (sportId !== null) {
				if (vm.isOpen == false) {
					// drop menu is closed. scroll to menu item immediatley
					vm.scrollTo(sportId);
				} else {
					// drop menu is open, delay before scrolling to menu item
					setTimeout(() => {
						vm.scrollTo(sportId);
					}, 100);
				}
			} else {
				// use sport id from selected sport
				if (vm.$store.getters.selectedSport !== null) {
					sportId = vm.$store.getters.selectedSport.sport_id;
					// drop menu is open, delay before scrolling to menu item
					setTimeout(() => {
						vm.scrollTo(sportId);
					}, 100);
				}
			}
		},
		scrollTo(sportId) {
			const unionSportRef = "union_" + sportId;
			this.$refs[unionSportRef][0].scrollIntoView({
				behavior: "smooth",
				inline: "center",
				block: "nearest",
			});
		},
		swipeOpen() {
			this.isOpen = true;
		},
		swipeRight() {
			if (this.isDragging == false) {
				this.swipeClose();
			}
		},
		swipeClose() {
			this.draggingDisabled = true;
			this.isOpen = false;
		},
		onMove({ relatedContext, draggedContext }) {
			const relatedElement = relatedContext.element;
			const draggedElement = draggedContext.element;
			return (
				(!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
			);
		},
		reset() {
			// Emit event that will reset the sports list. Event is called in App.vue
			this.$root.$emit("reset-sports-list");
			this.closeBottomSheet();
		},
		showBottomSheet() {
			this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
		handleClosedToast() {
			// Save toast viewed preference
			this.$store.commit("settings/updateToastDropMenu", true);
			this.toastVisible = false;
		},
		getUnionSportsItemsOrder() {
			let vm = this;
			let unionSportsItems = this.$store.getters["navigation/unionSports"];
			let itemsSummary = unionSportsItems.map((item, index) => {
				return {
					key: vm.formatSportName(item.sport_name) + "_" + index,
					item: item.sport_name,
				};
			});

			return itemsSummary;
		},
		sendDlp() {
			let vm = this;
			if (!_.isEqual(vm.currentUnionSports, vm.unionSports)) {
				// Order has changed, send analytics
				const items = vm.getUnionSportsItemsOrder();
				// analytics.dropMenu.reOrdered({
				// 	itemsOrder: items,
				// });
			}
		},
		productTourOnStart() {
			this.isTourOpen = true;
		},
		productTourOnPreviousStep(currentStep) {
			this.isTourOpen = true;
		},
		productTourOnNextStep(currentStep) {
			this.isTourOpen = true;
		},
		productTourOnSkip() {
			this.isTourOpen = false;
			this.isTourDone = true;
			this.$store.dispatch(
				"productTour/updateProductTourDropMenuCompleted",
				true
			);
		},
		productTourOnFinish() {
			this.isTourOpen = false;
			this.isTourDone = true;
			this.$store.dispatch(
				"productTour/updateProductTourDropMenuCompleted",
				true
			);
		},
		productTourOnStop() {
			this.isTourOpen = false;
			this.isTourDone = true;
			this.$store.dispatch(
				"productTour/updateProductTourDropMenuCompleted",
				true
			);
		},
	},
	watch: {
		isDragging(newValue) {
			if (newValue) {
				this.delayedDragging = true;
				return;
			}
			this.$nextTick(() => {
				this.delayedDragging = false;
			});
		},
	},
};
</script>

<style lang="scss">
.divider {
	width: calc(100% - 65px);
	height: 1px;
	background-color: var(--light-gray);
	margin: 16px 30px;
	padding: 0px 0px;
	//float: left;
	@media (max-width: 320px) {
		margin: 4px 30px;
	}
	@media (min-width: 321px) and (max-width: 360px) {
		margin: 8px 30px;
	}
	@media (min-width: 361px) and (max-width: 375px) {
		margin: 12px 30px;
	}
	@media (min-width: 376px) {
		margin: 15px 30px;
	}
}
.toast-container {
	//float: left;
	margin: 16px 16px;
	width: calc(100% - 16px);
}

.no-border {
	border: none;
}

.flip-list-move {
	transition: all 0.2s ease;
}
.fade-enter-active {
	transition: all 0.3s ease;
}
.fade-leave-active {
	transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter, .fade-leave-to
	/* .slide-fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
.no-move {
	transition: transform 0s;
}
.ghost {
	opacity: 0.8;
	border-radius: 8px;
	background: var(--lightest-green);
	transform: translateY(-38px);

	@media (max-width: 320px) {
		min-width: 61px;
	}
	@media (min-width: 321px) and (max-width: 360px) {
		min-width: 68px;
	}
	@media (min-width: 361px) and (max-width: 375px) {
		min-width: 74px;
	}
	@media (min-width: 376px) {
		min-width: 72px;
	}
}
.new-badge {
	position: absolute;
	left: 28px;
	top: 3px;
}
.hidden {
	& {
		display: none;
	}
}
.main-sports-draggable-container {
	outline: none;
	width: 100%;
	padding: 0px;
	margin: 0px;
	overflow-x: hidden;
	.no-data-label {
		box-sizing: border-box;
		font-size: var(--font-small);
		font-weight: var(--font-weight-lighter);
		color: var(--light-dark-blue);
		text-align: center;
		margin: 0px 20px;
		box-sizing: content-box;
		width: calc(100% - 100px);
		padding: 26px;
		border: 1px dashed var(--light-dark-blue);
		border-radius: 8px;
		top: 8px;
		left: -9px;
		position: absolute;
	}
}
.main-sports-draggable {
	width: 100%;
	margin: 0px;
	padding: 0px;
	min-height: 55px;
	&.scroll-x {
		display: inline-flex;
		justify-content: space-between;
		align-content: center;
		align-items: center;
		overflow-x: scroll;
		min-width: 100%;
	}
}
.overlap {
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: 1fr;
	min-height: 55px;
	align-items: start;
}
.overlap-item-1 {
	grid-column-start: 1;
	grid-row-start: 1;
	z-index: 999999999;
}
.overlap-item-2 {
	grid-column-start: 1;
	grid-row-start: 1;
	z-index: 999999998;
}
.main-sports-transition-group {
	padding: 0px 10px;
	margin: 0px;
	display: grid;
	align-items: center;
	justify-content: space-around;
	grid-gap: 1px;
	grid-template-columns: repeat(5, max(55px));
	box-sizing: border-box;
	@media (max-width: 280px) {
		grid-template-columns: repeat(4, max(55px));
		grid-gap: 1px;
	}
	@media (min-width: 281px) and (max-width: 320px) {
		grid-template-columns: repeat(4, max(55px));
		grid-gap: 1px;
	}
	@media (min-width: 321px) and (max-width: 360px) {
		grid-gap: 3px;
	}
	@media (min-width: 361px) and (max-width: 375px) {
		grid-gap: 6px;
	}
	@media (min-width: 376px) {
		grid-gap: 6px;
	}
	@media (min-width: 469px) and (max-width: 1022px) {
		grid-template-columns: repeat(auto-fill, max(80px));
		grid-gap: 8px;
	}
	&.scroll-x {
		display: inline-flex;
		justify-content: space-between;
		overflow-x: scroll;
		min-width: 100%;
	}
	&.scroll-x-start{
		justify-content: flex-start;
	}
}
.draggable {
	width: 100%;
	margin: 0px;
	padding: 0px;
	min-height: 55px;
}
.transition-group {
	padding: 0px 10px;
	display: grid;
	align-items: baseline;
	justify-content: space-around;
	grid-gap: 1px;
	grid-template-columns: repeat(5, min(55px));
	box-sizing: border-box;
	@media (max-width: 280px) {
		grid-template-columns: repeat(4, max(55px));
		grid-gap: 1px;
	}
	@media (min-width: 281px) and (max-width: 320px) {
		grid-template-columns: repeat(4, max(55px));
		grid-gap: 1px;
	}
	@media (min-width: 321px) and (max-width: 360px) {
		grid-gap: 3px;
	}
	@media (min-width: 361px) and (max-width: 375px) {
		grid-gap: 6px;
	}
	@media (min-width: 376px) {
		grid-gap: 6px;
	}
	@media (min-width: 469px) and (max-width: 1022px) {
		grid-template-columns: repeat(auto-fill, max(80px));
		grid-gap: 8px;
	}
}
.block-layout {
	float: left;
	width: 100%;
	margin: 0px;
}

.sports-list-container {
	outline: none;
	display: flex;
	flex: auto;
	min-height: 55px;

	&.wrapper {
		margin-top: 10px;
	}
}
.drop-down-contents {
	flex: 1;
	width: calc(100% - 45px);
}
.more__container {
	background-color: var(--light-blue);
	flex: 0 0 45px;
	margin: 0px;
	width: 45px;
	min-height: 55px;
	max-height: 60px;
	height: 60px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: start;
	transition: all 0.4s ease;
	&.open {
		height: 200px;
		max-height: 200px;
		justify-items: center;
		justify-content: space-between;
		position: sticky;
	}
	div {
		width: 100%;
		height: 55px;
		display: flex;
		padding-left: 0px;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	svg {
		padding: 0px;
		//transition: all 0.4s ease;
		:hover {
			cursor: pointer;
		}
		&.open {
			margin-bottom: 7px;
		}
		&.closed {
			margin-bottom: 7px;
		}
		&.editing {
			transform: scale(1.1);
			height: 20px;
			width: 15px;
		}
	}
	.menu-button {
		transition: all 0.4s ease;
		height: 60px;
		padding: 0px;
		&:first-child {
			height: 60px;
			position: relative;
			.red-dot {
				width: 10px;
				height: 10px;
				border-radius: 50%;
				background-color: var(--red-2);
				position: absolute;
				top: 8px;
				left: 50%;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				color: var(--always-white);
				font-weight: var(--font-weight-bold);
				font-size: calc(var(--font-tiny) - 3px);
			}
		}
		&.editing {
			&:first-child {
				height: 60px;
			}
			& > span {
				font-size: calc(var(--font-smallest) - 1px);
			}
			// &:last-child {
			// 	padding-bottom: 10px;
			// }
			#reset {
				height: 20px;
				width: 24px;
				margin-bottom: 7px;
			}
		}
		span {
			font-weight: var(--font-weight-lighter);
			font-size: var(--font-small);
			color: var(--light-dark-blue-1);
		}
	}
}

.sports-list {
	width: 100%;
	height: 55px;
	overflow-x: hidden;
	border: none;
	overflow-y: hidden;
	max-width: var(--app-width);
	background: var(--white);
	padding: 0px;
	//transition: all .4s  cubic-bezier(1.0, 0.5, 0.8, 1.0);
	transition: all 0.4s cubic-bezier(1, 0.88, 1, 2);
	//transition: height 2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	@media (min-width: 1023px) {
		display: flex;
		flex: auto;
		min-height: 55px;
		flex-wrap: nowrap;
		justify-content: start;
		flex-direction: column;
		align-items: flex-start;
		max-width: none;
		width: calc(100% - 20px);
		background: var(--white);
		padding: 10px;
		position: sticky;
		top: calc(2px + var(--desktop-header-offset));
		height: calc(100vh - var(--desktop-header-offset) - 20px - 4px);
		overflow-x: hidden;
		overflow-y: auto;
		transition: all 0s ease;
	}
	&.open {
		display: flex;
		flex-direction: row;
		align-items: start;
		overflow-y: scroll;
		height: calc(100vh - 45px);
		min-height: calc(100vh - 45px);
		justify-content: start;
		background: var(--white-darken-1);
		border-bottom-right-radius: 16px;
		border-bottom-left-radius: 16px;
	}
	&__main__sports {
		background-color: var(--white-darken-1);
		width: 100%;
		padding: 0px;
		margin: 0px;
		position: relative;
		z-index: 1;

		&__container {
			min-height: 55px;
			//transition: all 0.4s ease;
			padding: 0px;
			margin: 0px;
			&__item {
				margin: 0px;
				padding: 8px;
				display: flex;
				flex-direction: column;
				flex: auto;
				flex-grow: 0;
				align-items: center;
				justify-content: center;
				//transition: all 0.4s ease;
				span {
					text-align: center;
					word-wrap: normal;
				}
				svg {
					width: 24px;
					height: 24px;
				}
				&.editing {
					animation: jiggle 0.2s infinite;
					-webkit-animation: jiggle 0.2s infinite;
					-moz-animation-duration: 0.2s;
					-moz-animation-name: jiggle;
					-moz-animation-iteration-count: infinite;

					span {
						min-height: 15px;
					}

					background-color: var(--line-11-1);
					margin: 0px;
					padding: 6px 1px;
					border-radius: 8px;
					@media (max-width: 320px) {
						min-width: 41px;
					}
					@media (min-width: 321px) and (max-width: 360px) {
						min-width: 54px;
					}
					@media (min-width: 361px) and (max-width: 375px) {
						min-width: 56px;
					}
					@media (min-width: 376px) {
						min-width: 58px;
					}
				}
			}
		}
	}
	&__favorites {
		width: 100%;
		min-height: 85px;
		padding: 5px 16px;
		flex: auto;
		//transition: all 0.4s ease;
		&.close {
			display: none;
		}
		.no-data-label {
			font-size: var(--font-small);
			font-weight: var(--font-weight-lighter);
			color: var(--light-dark-blue);
			text-align: center;
			margin: 0px auto;
			margin-top: -80px;
			padding: 26px;
			border: 1px dashed var(--light-dark-blue);
			border-radius: 8px;
		}
		&__item {
			margin: 0px;
			margin-top: 5px;
			padding: 8px;
			display: flex;
			flex-direction: column;
			flex: auto;
			flex-basis: 15%;
			flex-grow: 0;
			align-items: center;
			justify-content: center;
			//transition: all 0.4s ease;
			svg {
				width: 24px;
				height: 24px;
			}
			span {
				font-size: var(--font-small);
				width: 50px;
				word-wrap: normal;
				text-align: center;
				white-space: pre-wrap;
				width: 50px;
			}
			&.editing {
				background-color: var(--line-11);
				margin: 0px;
				padding: 5px;
				border-radius: 8px;
				transform: scale(0.9);
				min-width: 47px;

				span {
					min-height: 15px;
				}
			}
		}
	}
	&__other__sports {
		//background-color: blue;
		//float: left;
		width: 100%;
		//flex: auto;
		padding: 0px;
		margin: 0px;
		position: relative;
		opacity: 1;
		transition: height 0.3s, opacity 0.3s cubic-bezier(1, 0.5, 0.8, 1);

		&__container {
			//width: calc(100% - 45px);
			min-height: 55px;
			//transition: all 0.4s ease;
			padding: 0px;
			margin: 0px;
		}
		&.close {
			opacity: 0;
		}
		.no-data-label {
			font-size: var(--font-small);
			font-weight: var(--font-weight-lighter);
			color: var(--light-dark-blue);
			text-align: center;
			margin: 0px 15px;
			margin-top: -30px;
			padding: 26px;
			border: 1px dashed var(--light-dark-blue);
			border-radius: 8px;
			width: calc(100% - 45px);
			box-sizing: border-box;
		}
		&__item {
			margin: 0px;
			padding: 8px;
			display: flex;
			flex-direction: column;
			flex: auto;
			flex-grow: 0;
			align-items: center;
			justify-content: center;
			//transition: all 0.4s ease;
			span {
				text-align: center;
				word-wrap: normal;
				white-space: pre-wrap;
				font-size: var(--font-small);
			}
			svg {
				width: 24px;
				height: 24px;
			}
			&.editing {
				animation: jiggle 0.2s infinite;
				-webkit-animation: jiggle 0.2s infinite;
				-moz-animation-duration: 0.2s;
				-moz-animation-name: jiggle;
				-moz-animation-iteration-count: infinite;

				span {
					min-height: 15px;
				}

				background-color: var(--line-11-1);
				margin: 0px;
				padding: 6px 1px;
				border-radius: 8px;

				@media (max-width: 320px) {
					min-width: 41px;
				}
				@media (min-width: 321px) and (max-width: 360px) {
					min-width: 54px;
				}
				@media (min-width: 361px) and (max-width: 375px) {
					min-width: 56px;
				}
				@media (min-width: 376px) {
					min-width: 58px;
				}
			}
		}
	}
	&__other__links {
		//background-color: orange;
		//display: block;
		//flex: auto;
		width: 100%;
		padding: 0px;
		margin: 0px;
		position: relative;
		opacity: 1;
		transition: height 0.3s, opacity 0.3s cubic-bezier(1, 0.5, 0.8, 1);

		&__container {
			//width: calc(100% - 45px);
			min-height: 55px;
			//transition: all 0.4s ease;
			padding: 0px;
			margin: 0px;
			&__item {
				margin: 0px;
				padding: 8px;
				display: flex;
				flex-direction: column;
				flex: auto;
				flex-grow: 0;
				align-items: center;
				justify-content: center;
				//transition: all 0.4s ease;
				span {
					width: 60px;
					word-wrap: normal;
					text-align: center;
					white-space: pre-wrap;
					font-size: var(--font-small);
				}
				svg {
					width: 24px;
					height: 24px;
				}
				&.editing {
					animation: jiggle 0.2s infinite;
					-webkit-animation: jiggle 0.2s infinite;
					-moz-animation-duration: 0.2s;
					-moz-animation-name: jiggle;
					-moz-animation-iteration-count: infinite;

					span {
						min-height: 15px;
					}

					background-color: var(--line-11-1);
					margin: 1px 0px 3px 0px;
					padding: 6px 2px;
					margin-bottom: 3px;
					border-radius: 8px;

					@media (max-width: 320px) {
						min-width: 41px;
					}
					@media (min-width: 321px) and (max-width: 360px) {
						min-width: 54px;
					}
					@media (min-width: 361px) and (max-width: 375px) {
						min-width: 56px;
					}
					@media (min-width: 376px) {
						min-width: 58px;
					}
				}
			}
		}
		&.close {
			opacity: 0;
		}
		.no-data-label {
			font-size: var(--font-small);
			font-weight: var(--font-weight-lighter);
			color: var(--light-dark-blue);
			text-align: center;
			margin: 0px auto;
			margin-top: -80px;
			padding: 26px;
			border: 1px dashed var(--light-dark-blue);
			border-radius: 8px;
		}
		&__item {
			margin: 0px;
			margin-top: 5px;
			padding: 8px;
			display: flex;
			flex-direction: column;
			flex: auto;
			flex-basis: 15%;
			flex-grow: 0;
			align-items: center;
			justify-content: center;
			//transition: all 0.4s ease;
			span {
				width: 70px;
				text-align: center;
				word-wrap: normal;
			}
			&.editing {
				border: 1px solid var(--line-11);
				margin: 0px;
				padding: 5px;
				border-radius: 8px;
				transform: scale(0.9);

				span {
					min-height: 15px;
				}
			}
		}
	}
	&__live__sports {
		width: 100%;
		min-height: 60px;
		padding: 0px 0px;
		padding-right: 8px;
		display: flex;
		flex-direction: row;
		align-items: start;
		justify-content: start;
		overflow-x: scroll;
		overflow-y: hidden;
		padding-right: 20px;
		transition: all 0.4s ease;
		background: var(--white-darken-1);
		flex: auto;
		&.close {
			display: none;
		}
		.no-data-label {
			font-size: var(--font-small);
			font-weight: var(--font-weight-lighter);
			color: var(--light-dark-blue);
			text-align: center;
			margin: 0px auto;
			margin-top: -80px;
			padding: 26px;
			border: 1px dashed var(--light-dark-blue);
			border-radius: 8px;
		}
		&__item {
			margin: 0px;
			margin-top: 5px;
			padding: 8px;
			display: flex;
			flex-direction: column;
			flex: auto;
			flex-basis: 15%;
			flex-grow: 0;
			align-items: center;
			justify-content: center;
			transition: all 0.4s ease;
			span {
				font-size: var(--font-smallest);
				width: 60px;
				text-align: end;
			}
			svg {
				width: 22px;
				height: 22px;
			}
			&.editing {
				border: 1px solid var(--line-11);
				margin: 0px;
				padding: 5px;
				border-radius: 8px;
				transform: scale(0.85);
			}
		}
	}
	&__item {
		background: none;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border: none;
		text-decoration: none;
		transition: all 0.4s ease;

		@media (min-width: 1023px) {
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;
			cursor: pointer;
			padding: 8px;
		}
		&__icon {
			width: 20px;
			height: 20px;
			margin-bottom: 5px;
			fill: var(--light-dark-blue);
			&__container {
				position: relative;
			}
			@media (min-width: 1023px) {
				width: 20px;
				height: 20px;
				margin: 0;
				margin-right: 10px;
			}
		}
		&__label {
			font-size: var(--font-small);
			white-space: nowrap;
			color: var(--light-dark-blue-1);
			font-weight: var(--font-weight-lighter);
			&.editing {
				font-size: calc(var(--font-smallest) - 1px);
			}
			&.open {
				width: 60px;
				white-space: normal;
			}
			// &.narrow {
			// 	// width: 40px !important;
			// }
		}
		&__count {
			font-size: var(--font-small);
			color: var(--light-dark-blue);
			position: absolute;
			top: -2px;
			right: -10px;
			@media (min-width: 1023px) {
				position: inherit;
				top: unset;
				right: unset;
				background: var(--main-bg-color);
				padding: 2px 10px;
				border-radius: 10px;
				margin-left: 5px;
				float: right;
			}
		}
		&.active {
			.sports-list__item__label {
				color: var(--black);
				font-weight: var(--font-weight-bold);
			}
			.sports-list__item__icon {
				fill: var(--black);
			}
		}
	}
	.open,
	.closed {
		.more__container {
			background-color: var(--white-darken-1);
		}
	}
}
.bottom-sheet {
	height: 40vh;
	&__container {
		padding: 0 calc(var(--base-padding) + 10px);
	}
	&__buttons {
		&__container {
			padding: 5px 0;
			& > button {
				margin: 10px 0;
			}
		}
	}
	&__title {
		font-size: var(--font-large);
		color: var(--light-black);
	}
	&__text {
		font-size: var(--font-small);
		color: var(--light-black);
		font-weight: var(--font-weight-normal);
	}
}

@keyframes jiggle {
	0% {
		transform: rotate(-1deg);
		animation-timing-function: ease-in;
	}
	50% {
		transform: rotate(1.5deg);
		animation-timing-function: ease-out;
	}
}

@-webkit-keyframes jiggle {
	0% {
		-webkit-transform: rotate(-1deg);
		-webkit-animation-timing-function: ease-in;
	}
	50% {
		-webkit-transform: rotate(1.5deg);
		-webkit-animation-timing-function: ease-out;
	}
}

@-moz-keyframes jiggle {
	0% {
		-moz-transform: rotate(-1deg);
		-moz-animation-timing-function: ease-in;
	}
	50% {
		-moz-transform: rotate(1.5deg);
		-moz-animation-timing-function: ease-out;
	}
}
@keyframes jiggle2 {
	0% {
		transform: rotate(1deg);
		animation-timing-function: ease-in;
	}
	50% {
		transform: rotate(-1.5deg);
		animation-timing-function: ease-out;
	}
}

@-webkit-keyframes jiggle2 {
	0% {
		-webkit-transform: rotate(2deg);
		-webkit-animation-timing-function: ease-in;
	}
	50% {
		-webkit-transform: rotate(-2.5deg);
		-webkit-animation-timing-function: ease-out;
	}
}
@-moz-keyframes jiggle2 {
	0% {
		-moz-transform: rotate(1deg);
		-moz-animation-timing-function: ease-in;
	}
	50% {
		-moz-transform: rotate(-1.5deg);
		-moz-animation-timing-function: ease-out;
	}
}
.v-tour__target--highlighted {
	box-shadow: 0 0 0 99999px rgba(232, 232, 232, 0.72) !important;
}
</style>
